// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__fep9H","layout-body":"style_layout-body__crbN1"};